import { c as _c } from "react/compiler-runtime";
import { MemberAvatars } from "@components/common/member/member-avatars";
import { compareMembersByDefaultName } from "@components/table/members/members-table-utils";
/**
 * Shows avatars of the team members of a team
 */
export function TeamsMembersColumn(t0) {
  const $ = _c(5);
  const {
    members,
    membersCount
  } = t0;
  let t1;
  if ($[0] !== members) {
    t1 = members.sort(_temp);
    $[0] = members;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortedTeamMembers = t1;
  let t2;
  if ($[2] !== membersCount || $[3] !== sortedTeamMembers) {
    t2 = <MemberAvatars members={sortedTeamMembers} maxMemberAvatars={4} membersCount={membersCount} size={32} />;
    $[2] = membersCount;
    $[3] = sortedTeamMembers;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(a, b) {
  return compareMembersByDefaultName(a, b, "ascending");
}